module.exports = __webpack_public_path__ + "img/typolibris.10d3aec9.jpg";